import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import DOT_NOTIFICATION from './dot-notification.palette-schema.yaml';

registerTileSchema(DOT_NOTIFICATION);

export function generateDotNotification(TILE) {
    return {
        style: {
            container: {
                padding: '2px',
                right: '0px',
                top: '0px',
                borderRadius: '8px',
            },

            dot: {
                height: '8px',
                width: '8px',
                borderRadius: '8px',
                ...resolveBackground(TILE.DOT_COLOR),
            },

            dotWithText: {
                minHeight: '8px',
                minWidth: '8px',
                borderRadius: '8px',
                padding: '0px 4px',
                ...resolveBackground(TILE.DOT_COLOR),
            },
        },
    };
}
